import { IAssessmentComposite } from "@/modules/assessments/hooks/use-get-assessment-composites-by-invite.hook";
import AssessmentTemplateCard from "../AssessmentTemplateCard/AssessmentTemplateCard";
import AssessmentTemplateBarChartComponent from "../../charts/BarChart/AssessmentTemplateBarChartComponent";
interface ISubCompositeCardProps {
  composite: IAssessmentComposite;
  cardStyle?: React.CSSProperties;
  cardClassName?: string;
}

export default function SubCompositeCard({ composite }: ISubCompositeCardProps) {
  return (
    <AssessmentTemplateCard
      description={composite.definition}
      compositeScore={composite.finalScore}
      compositeTitle={composite.title}
      icon={composite.icon}
      isSubComposite={true}
    >
      <AssessmentTemplateBarChartComponent
        usersChartData={[
          {
            value: composite.finalScore,
          },
        ]}
        min_max={[0, 5]}
      />
      {composite.subComposites &&
        composite.subComposites.map((subComposite) => (
          <SubCompositeCard key={subComposite.compositeKey} composite={subComposite} />
        ))}
    </AssessmentTemplateCard>
  );
}
